module.exports = __webpack_public_path__ + "media/images/lb/492-77bf7d1094d07a374f40e650f40c9c05.svg";